import { Button, Panel, Stack } from "@/components/ui";

import { runLabel, runStatusOf } from "../lib/runState";
import { useConsole } from "../store";

import { Dot, Muted } from "./Text";

/** A space verb answers one outcome per added activity. Partial success renders as partial. */
export function CascadeOutcomes() {
  const cascade = useConsole((state) => state.cascade);
  const clear = useConsole((state) => state.clearCascade);
  if (cascade === null) return null;

  const done = cascade.activities.filter((one) => one.succeeded).length;

  return (
    <Panel
      title={`${cascade.verb}: ${cascade.space_name}`}
      tone="sunken"
      action={
        <Button size="sm" variant="ghost" onClick={clear}>
          Dismiss
        </Button>
      }
    >
      <Stack gap={3}>
        <Muted small>{`${String(done)} of ${String(cascade.activities.length)} succeeded`}</Muted>
        {cascade.activities.map((one) => (
          <div
            key={one.added_activity_id}
            className={one.succeeded ? "cx-outcome" : "cx-outcome cx-outcome-bad"}
          >
            <Dot tone={one.succeeded ? "live" : "warn"} />
            <b>{one.name}</b>
            <span className="cx-outcome-why">
              {one.succeeded ? runLabel(runStatusOf(one.mount ?? null)) : (one.reason ?? "refused")}
            </span>
          </div>
        ))}
      </Stack>
    </Panel>
  );
}
